import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "@cmde/shadcn/styles";

import App from "./App";
import { env } from "./config/environment-vars";
import { Auth0Provider, type AppState } from "@auth0/auth0-react";

const routerBase =
  import.meta.env.BASE_URL === "/"
    ? ""
    : import.meta.env.BASE_URL.replace(/\/$/, "");

const onRedirectCallback = (appState?: AppState) => {
  const targetUrl =
    appState?.targetUrl ||
    `${routerBase}${window.location.pathname}${window.location.search}`;

  window.history.replaceState(
    {},
    document.title,
    targetUrl,
  );
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Auth0Provider
      domain={env.VITE_AUTH0_DOMAIN}
      clientId={env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <App />
    </Auth0Provider>
  </StrictMode>,
);
